export const phoneRegex = /^[6-9]\d{9}$/;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;